import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type EmberStore from "cc-frontend/services/ember-store"
import type ModalManager from "cc-frontend/services/modal-manager"
import type { ModalName } from "cc-frontend/services/modal-manager"
import { easeIn, easeOut } from "ember-animated/easings/cosine"
import move from "ember-animated/motions/move"
import { fadeIn, fadeOut } from "ember-animated/motions/opacity"
import { difference, forEach } from "lodash-es"

interface Args {
  updateOpenedModals: Function
  openedModals: Array<ModalName>
}

export default class ModalManagerComponent extends Component<Args> {
  @service("ember-store") store!: EmberStore
  @service modalManager!: ModalManager

  @action closeModal(modalName) {
    this.modalManager.closeModal(modalName)
  }

  slideoutTransition = function* ({ insertedSprites, keptSprites, removedSprites }) {
    insertedSprites.forEach((sprite) => {
      sprite.startAtPixel({ x: window.innerWidth })
      fadeIn(sprite, { easing: easeOut, duration: 150 })
      move(sprite, { easing: easeOut, duration: 150 })
    })

    keptSprites.forEach(move)

    removedSprites.forEach((sprite) => {
      sprite.endAtPixel({ x: window.innerWidth })
      move(sprite, { easing: easeIn, duration: 150 })
      fadeOut(sprite, { easing: easeIn, duration: 150 })
    })
  }

  fullScreenTransition = function* ({ insertedSprites, removedSprites }) {
    insertedSprites.forEach((sprite) => {
      fadeIn(sprite, { easing: easeOut, duration: 150 })
    })

    removedSprites.forEach((sprite) => {
      fadeOut(sprite, { easing: easeIn, duration: 150 })
    })
  }

  @action updateOpenedModals() {
    this.args.updateOpenedModals(this.modalManager.openedModals)
  }

  @action checkOpenedModals() {
    let closedModals = difference(this.modalManager.openedModals, this.args.openedModals)
    forEach(closedModals, (modalName) => this.modalManager.closeModal(modalName))
  }
}
